import { render, staticRenderFns } from "./CrearDerivacionesInterconsultas.vue?vue&type=template&id=df6fa7d0"
import script from "./CrearDerivacionesInterconsultas.vue?vue&type=script&lang=js"
export * from "./CrearDerivacionesInterconsultas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports